import { Check } from 'lucide-react';

export const ImproveThisActivitySheet = ({ title }) => {
  return (
    <div className="flex flex-col">
      <p className="typography-h2 text-primary mt-4">
        How to improve this activity
      </p>
      <div className="bg-white rounded-xl p-4 flex items-center justify-between w-full mt-4">
        <div className="flex items-center gap-3">
          <div className="w-5 h-5 rounded-full bg-background-success flex items-center justify-center">
            <Check className="w-3 h-3 text-white" />
          </div>
          <span className="typography-body text-primary line-clamp-1 text-start">
            {title}
          </span>
        </div>
      </div>
      <p className="typography-body text-tertiary mt-4">
        Your recommendations will focus on combatting harmful microbial
        metabolites that can impair memory, focus, and mental clarity, ensuring
        optimal brain function.
      </p>
    </div>
  );
};

export const ImproveThisActivitySheetSkeleton = () => {
  return (
    <div className="flex flex-col animate-pulse">
      <div className="h-8 w-56 bg-gray-200 rounded mt-4 mb-4"></div>
      <div className="bg-gray-100 rounded-xl p-4 flex items-center justify-between w-full">
        <div className="flex items-center gap-3">
          <div className="w-5 h-5 rounded-full bg-gray-200"></div>
          <div className="h-5 w-48 bg-gray-200 rounded"></div>
        </div>
      </div>
      <div className="mt-4 space-y-2">
        <div className="h-4 w-full bg-gray-200 rounded"></div>
        <div className="h-4 w-5/6 bg-gray-200 rounded"></div>
        <div className="h-4 w-4/6 bg-gray-200 rounded"></div>
      </div>
    </div>
  );
};
